import { Translate } from "../../constant/Translate"

const { TEXT_T090, TEXT_T091, TEXT_T138 } = Translate

export const getWorkPlaceLocation = (value?: number) =>
  value === 1 ? TEXT_T090 : value === 2 ? TEXT_T091 : TEXT_T138
